import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'inc-title-btn',
  templateUrl: './title-btn.component.html',
  styleUrls: ['./title-btn.component.scss'],
})
export class TitleBtnComponent {
  @Input() title: string;
  @Input() btnTxt: string;
  @Output() callClick: EventEmitter<any> = new EventEmitter();

  constructor() { }

  click() {
    this.callClick.emit();
  }

}
